module.exports = __webpack_public_path__ + "img/e-company.53e5a7e8.jpg";